import { useState } from "react";
import LazyLoad from "react-lazyload";

import dynamic from "next/dynamic";

import { Tab } from "@headlessui/react";

import dataTrustpilot from "common/data/trustpilot/data.json";
import useResizeScreenModified from "common/hooks/useResizeScreenModified";

import Img from "components/atoms/Img";
import LinkRouter from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";
import FaqsGroup from "components/molecules/FaqsGroup";
import TabListNew from "components/molecules/TabListNew/index";
import Banner from "components/organisms/Banner/index.js";
import Faqs from "components/organisms/Faqs";
import TrustpilotFeedBack from "components/organisms/TrustpilotFeedBack";

const NewsSlider = dynamic(() => import("components/organisms/NewsSlider"), {
  ssr: false,
});

/** ========== */

const CorporateSecretary = ({ dataJson, data }) => {
  const [screen, setScreen] = useState();

  useResizeScreenModified(setScreen);

  return (
    <>
      <Banner
        minHeightBanner="banner-min-h-569"
        wave={
          <div className="col-12 absolute bottom-0 hidden lg:block ">
            <Img
              src="/assets/images/wave/curve_top-wave.svg"
              className="h-full w-full"
              width={516}
              height={420}
              wrapper={{
                className: "w-full h-full",
              }}
              alt="banner-img"
            />
          </div>
        }
        breadcrumbs={dataJson?.breadcrumbs}
        title="Corporate Secretary<br/>Made Simple"
        leftContent={
          <p className="mb-6 text-center lg:col-11 lg:mb-14 lg:text-left ">
            Stay covered year-round with our corporate secretarial service for
            Hong Kong business.
          </p>
        }
        titleProps={{
          className: "banner-default-title mb-6",
          textColor: "banner-title-default-color",
        }}
        leftClassName="lg:col-6"
        rightClassName="lg:col-6"
        rightContent={
          <Img
            src="/assets/images/hk/corporate-secretary/banner-hk-secretary.png"
            className="h-full w-full"
            wrapper={{
              className: "bbc-banner-image-bottom-0",
            }}
            width={666}
            height={542}
            alt="Hong Kong company secretary service"
          />
        }
        bgColor="bg-bbc-country"
      ></Banner>
      <div className="bg-bbc-brand-100 pt-10 lg:pt-20">
        <div className="container">
          <div className=" mb-10 lg:mb-20">
            <Title className="title-h2 mb-4 text-center text-bbc-brand-800  lg:mb-6">
              Break free from corporate governance hassle
            </Title>
            <p className="mb-6">
              According to Section 474, Cap. 622 Companies Ordinance, every
              business entities in Hong Kong have to maintain a corporate
              secretary at all times for administrative tasks. Appointing a
              corporate secretary is compulsory for any entrepreneur looking to
              set up a company in Hong Kong.
            </p>
            <p>
              So, what are the key duties of a corporate secretary in Hong Kong?
            </p>
            <ul className="mb-6 list-disc pl-8">
              <li>
                Work with regulatory bodies and agencies such as Hong Kong
                Registrar of Companies, Stock Exchange of Hong Kong, etc.
              </li>
              <li>
                Ensure the company and its operation are fully compliant with
                all statutory laws
              </li>
              <li>
                Take care of tax reports, keeping of statutory books, meeting
                arrangements and related corporate changes to relevant
                authorities
              </li>
            </ul>
            <p>
              With a skillful and professional team, we&lsquo;ll sort out your
              secretarial work and free you from compliance risks that could set
              you back.
            </p>
          </div>
          <div className="pb-10">
            <Title className="title-h2 mb-4 text-center text-bbc-brand-800  lg:mb-6">
              Why choosing our corporate secretarial service
            </Title>
            <p>
              We handle your filings, formalities, and deadlines. So you can be
              sure your Hong Kong business is in good standing at all times!
            </p>
            <div className="mt-6 lg:mt-10">
              <div className="row items-center justify-between">
                <div className="mb-6 lg:col-6 lg:mb-0">
                  <Title as="h3" className="bbc-title-30">
                    Meet deadlines
                  </Title>
                  <p>
                    We keep you updated with important deadlines, making sure
                    the tax obligations of your Hong Kong business are matched
                    on time and in an efficient manner at the end of every
                    fiscal year.
                  </p>
                </div>
                <div className="text-center lg:col-6 lg:text-right">
                  {" "}
                  <Img
                    src="/assets/images/hk/corporate-secretary/services1-hk-secretary.png"
                    className="h-full lg:w-full"
                    width={547}
                    height={435}
                    alt="help you meet deadlines"
                  />
                </div>
              </div>
            </div>
            <div className="mt-10">
              <div className="row flex-col-reverse items-center justify-between lg:flex-row">
                <div className="text-center lg:col-6 lg:text-left">
                  {" "}
                  <Img
                    src="/assets/images/hk/corporate-secretary/services2-hk-secretary.png"
                    width={452}
                    height={367}
                    alt="keep you updated"
                  />
                </div>
                <div className="mb-6 lg:col-6 lg:mb-0">
                  <Title as="h3" className="bbc-title-30">
                    Update information
                  </Title>
                  <p className="mb-6">
                    We handle your mandatory filings and protocol.
                  </p>
                  <p>
                    We also make sure your company info is up-to-date, record
                    any changes (i.e, you change the shareholder structure,
                    company names, or address) and arrange amendment filings
                    with relevant authorities if necessary. So you don&lsquo;t
                    get hit with fines and penalties that could hurt your bottom
                    line.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-10">
              <div className="row items-center justify-between ">
                <div className="lg:col-6">
                  <Title as="h3" className="bbc-title-30">
                    Stay compliant
                  </Title>
                  <p>
                    Get support from our team of experts to fulfil your
                    governance requirements and stay in good standing all the
                    time.
                  </p>
                </div>
                <div className="text-center lg:col-6 lg:text-right">
                  {" "}
                  <Img
                    src="/assets/images/hk/corporate-secretary/services3-hk-secretary.png"
                    width={513}
                    height={397}
                    alt="help you stay compliant"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 mb-10 hidden lg:mb-20 lg:block">
        <Img
          src="/assets/images/wave/curve_bot-wave.svg"
          className="h-full w-full"
          width={516}
          wrapper={{
            className: "w-full h-full",
          }}
          height={420}
          alt="banner-img"
        />
      </div>
      <section>
        <div className="container">
          <Title className="title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10">
            Pricing
          </Title>
          <TabListNew
            data={dataJson.dataPricing.data.map((item) => item.tab)}
            activeTab={dataJson.dataPricing.activeTab}
            tabListClass={{
              display: "flex lg:justify-center",
              length: "w-full",
              padding: "px-1 py-3",
              border: "border-0",
              othersClass: "whitespace-nowrap overflow-x-auto mb-20 lg:mb-6",
            }}
            tabClass={{
              padding: "py-2 px-4 ",
              tabColor:
                "text-bbc-neutral-600 border-bbc-neutral-600 hover:text-bbc-brand-500 hover:border-bbc-brand-500",
              othersClass: "mr-2 last:mr-0 font-medium",
            }}
          >
            <Tab.Panels>
              {dataJson.dataPricing.data.map((item, index) => {
                return (
                  <Tab.Panel
                    className="focus:outline-none focus:outline-0 focus:ring-0"
                    as="div"
                    key={index}
                  >
                    <div className="shadow-bbc-table mt-10 hidden overflow-x-auto rounded-3xl lg:block">
                      <table className=" text-left text-sm text-bbc-gray ">
                        <thead className="col-12 bg-bbc-brand-700  text-2xl  text-bbc-white ">
                          <tr>
                            {item.table?.thead?.map((thead, index) => {
                              return (
                                <th
                                  key={index}
                                  className={`${thead.width} py-8 text-center font-semibold`}
                                >
                                  {thead.name}
                                </th>
                              );
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {item.table?.tbody?.map((thead, index) => {
                            return (
                              <tr
                                key={index}
                                className=" bg-bbc-white even:bg-bbc-brand-100"
                              >
                                <th className="w-1/6 px-4 py-6 align-top font-medium text-bbc-brand-700">
                                  {thead.title}
                                </th>
                                <td
                                  className="relative w-4/6 py-6 align-top
                                 before:absolute before:left-0 before:top-6 before:h-[calc(100%_-_48px)] before:w-[1px] before:bg-bbc-neutral-700 before:content-['']
                                 after:absolute after:right-0 after:top-6 after:h-[calc(100%_-_48px)] after:w-[1px] after:bg-bbc-neutral-700 after:content-['']"
                                >
                                  <p className="  px-6  ">
                                    {thead.description}
                                  </p>
                                </td>
                                <td className="w-1/6 px-4 py-6 text-center align-top">
                                  {thead.price ? (
                                    <ul
                                      className="list-disc font-semibold text-bbc-brand-700 "
                                      dangerouslySetInnerHTML={{
                                        __html: thead.price,
                                      }}
                                    />
                                  ) : (
                                    <LinkRouter
                                      href="/contact-us"
                                      className="font-semibold text-bbc-brand-700"
                                    >
                                      Contact us
                                    </LinkRouter>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-6 block lg:hidden">
                      {item.table?.tbody?.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="mb-4  rounded-2xl bg-bbc-white shadow-[0_16px_40px_0_rgba(181,181,181,0.25)]"
                          >
                            <h5 className="border-b border-bbc-neutral-500 py-4 text-center font-medium text-bbc-brand-600">
                              {item.title}
                            </h5>
                            <p className="border-b border-bbc-neutral-500 py-6 px-7 text-center">
                              {item.description}
                            </p>
                            <p className="py-4 text-center">
                              {item.price ? (
                                <p
                                  className="font-semibold text-bbc-brand-700 "
                                  dangerouslySetInnerHTML={{
                                    __html: item.price,
                                  }}
                                />
                              ) : (
                                <LinkRouter
                                  href="/contact-us"
                                  className="font-semibold text-bbc-brand-700 "
                                >
                                  Contact us
                                </LinkRouter>
                              )}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </Tab.Panel>
                );
              })}
            </Tab.Panels>
          </TabListNew>
        </div>
      </section>
      <section>
        <div className="container">
          <Title className="title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10">
            Proactive, professional, and passionate
          </Title>
          <p className=" m-auto text-center lg:col-8 ">
            Whatever business you&lsquo;re doing, be confident you&lsquo;re in
            the best hand. When it comes to corporate secretarial service, you
            won&lsquo;t find a more committed team.
          </p>

          <div className="row mt-10 justify-center">
            <div className="mt-6 flex items-center lg:col-5 lg:mr-6">
              {screen === "DESKTOP" ? (
                <FaqsGroup data={dataJson.dataProactive} />
              ) : (
                <ul>
                  {dataJson.dataProactive.map((item, index) => (
                    <li key={index} className="mx-4 mb-10 text-center">
                      <div
                        className="mb-4"
                        dangerouslySetInnerHTML={{ __html: item.name }}
                      />
                      <div dangerouslySetInnerHTML={{ __html: item.content }} />
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="order-first text-center lg:col-6 lg:order-last lg:ml-6">
              <Img
                src="/assets/images/hk/corporate-secretary/services4-hk-secretary.png"
                width={513}
                height={403}
                alt="why choose our corporate secretary service"
              />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="m-auto lg:col-10">
            <Title className="title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10">
              What customers say about BBCIncorp
            </Title>
            <TrustpilotFeedBack data={dataTrustpilot.feedback} />
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="m-auto lg:col-10">
            <Faqs data={dataJson.dataFaqs} description=" " />
          </div>
        </div>
      </section>
      <section className="mb-0">
        <div className="container">
          <Title className="title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800">
            Industry News & Insights
          </Title>
          <LazyLoad>
            <NewsSlider data={data} />
          </LazyLoad>
        </div>
      </section>
    </>
  );
};

export default CorporateSecretary;
